var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEggIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1410126414",
    clipPath: "url(#clip0_242_5181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 734",
    d: "M12.4802 8.26833C12.4802 11.1994 10.0828 13.5838 7.11515 13.5838C4.14749 13.5838 1.75008 11.1994 1.75008 8.26833C1.75008 6.77976 2.36611 5.00099 3.38171 3.59632C4.40333 2.18333 5.73698 1.26745 7.11515 1.26745C8.49333 1.26745 9.82698 2.18333 10.8486 3.59632C11.8642 5.00099 12.4802 6.77976 12.4802 8.26833Z",
    fill: "white",
    stroke: "url(#paint0_linear_242_5181)",
    strokeWidth: 1.16667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 4250"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1929",
    x: 3.94238,
    y: 5.44278,
    width: 6.3703,
    height: 6.3703,
    rx: 3.18515,
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 568",
    d: "M6.84364 7.20918C7.15955 7.146 7.36442 6.83869 7.30124 6.52278C7.23806 6.20687 6.93074 6.00199 6.61483 6.06517L6.84364 7.20918ZM5.71208 9.72643C5.65903 9.40811 5.65784 8.78807 5.84021 8.23253C6.01906 7.68772 6.33041 7.31183 6.84364 7.20918L6.61483 6.06517C5.53549 6.28104 4.98421 7.09958 4.73174 7.86865C4.4828 8.62698 4.48163 9.44026 4.56129 9.91823L5.71208 9.72643Z",
    fill: "url(#paint1_linear_242_5181)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_242_5181",
    x1: 7.11515,
    y1: 0.684113,
    x2: 7.11515,
    y2: 14.1672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD29E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_242_5181",
    x1: 5.91351,
    y1: 6.63718,
    x2: 5.91351,
    y2: 9.82233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_242_5181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.554138)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggIcon);
export default __webpack_public_path__ + "static/media/EggIcon.979617d3cb452659aefe5599cb66ce23.svg";
export { ForwardRef as ReactComponent };